import { useNavigate } from "react-router-dom";
import logomain from "../../../images/logo-main.png";
import { ResetPaswordFunction } from "./ResetPaswordFunction";
import { useEffect, useState } from "react";
import { LoadPanel, Toast } from "devextreme-react";
import { useSelector } from "react-redux";
export const ResetPasword = () => {
  const clas = new ResetPaswordFunction();
  const Navigate = useNavigate();
  const [validation, setvalidation] = useState("");
  const [password, setpassword] = useState("");
  const [newpassword, setnewpassword] = useState("");
  const [isEyeOpen, setIsEyeOpen] = useState(false);
  const [isEyeOpen2, setIsEyeOpen2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const { token } = useSelector((store) => store.login);

  useEffect(() => {
    if (!token) {
      Navigate("/login");
    }
  }, [token, Navigate]);

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;

  function isPasswordValid(passwords) {
    return passwordRegex.test(passwords);
  }

  const Onsubmit = () => {
    if (password.trim() !== newpassword.trim()) {
      setvalidation(clas.ErrorValidationConstant2);
      return;
    }

    if (!isPasswordValid(newpassword.trim())) {
      setvalidation(clas.ErrorValidationConstant);
      return;
    }

    clas.ResetPasword(
      {
        new_password: newpassword,
      },
      Navigate,
      setToastConfig,
      toastConfig,
      setvalidation,
      token,
      setLoading
    );
  };

  function togglePwd() {
    setIsEyeOpen(!isEyeOpen);
  }
  function togglePwd2() {
    setIsEyeOpen2(!isEyeOpen2);
  }

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        position={"top"}
        width={"auto"}
      />
      <section className="login">
        <div className="container">
          <div className="login__flex">
            <div className="login__item login__item--img" />
            <div className="login__item login__item--form">
              <div className="branding">
                <div className="branding__logo">
                  <img
                    src={logomain}
                    alt="Logo | Welcome To UPA"
                    className="branding__logo__img"
                  />
                </div>
                <div className="branding__info">
                  <h1 className="title title--h1">Reset Your Password</h1>
                  <p className="text">Enter your password here!</p>
                </div>
              </div>
              <div className="login__form">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      Onsubmit();
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="form__group">
                    <label htmlFor="password" className="form__label">
                      Password
                    </label>
                    <div className="form__paswordfield">
                      <input
                        type={isEyeOpen ? "text" : "password"}
                        id="password"
                        className="form-control"
                        placeholder="Password"
                        style={{ border: validation ? "2px solid red" : "" }}
                        value={password}
                        onChange={(e) => {
                          setpassword(e.target.value);
                          setvalidation("");
                        }}
                      />
                      <button
                        onClick={togglePwd}
                        className={`eyebtn ${!isEyeOpen ? " " : " eyeopen"}`}
                      />
                    </div>
                  </div>
                  <div className="form__group">
                    <label htmlFor="password" className="form__label">
                      Re-enter Password
                    </label>
                    <div className="form__paswordfield">
                      <input
                        type={isEyeOpen2 ? "text" : "password"}
                        id="password2"
                        className="form-control"
                        style={{ border: validation ? "2px solid red" : "" }}
                        placeholder="Password"
                        value={newpassword}
                        onChange={(e) => {
                          setnewpassword(e.target.value);
                          setvalidation("");
                        }}
                      />
                      <button
                        onClick={togglePwd2}
                        className={`eyebtn ${!isEyeOpen2 ? " " : " eyeopen"}`}
                      />
                    </div>
                  </div>
                </form>
                {validation && (
                  <p
                    className="field-error"
                    style={{ marginTop: "-13px", width: "500px" }}
                  >
                    {validation}
                  </p>
                )}
                <div style={{ marginTop: "5%" }} className="form__group">
                  <button
                    className="btn btn--primary btn--full"
                    onClick={() => {
                      Onsubmit();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
